import React from 'react'
import PropTypes from 'prop-types'

function SubmitButton (props) {
  return (
    <button
      id={props.id}
      className={`${props.className}`}
      type='submit'
      disabled={props.disabled}
      aria-label='submit button'
    >
      {props.buttonValue}
    </button>
  )
}

SubmitButton.propTypes = {
  buttonValue: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string
}

SubmitButton.defaultProps = {
  buttonValue: 'Submit',
  className: 'btn-pink-new full-width-sm'
}

export default SubmitButton
